import React from 'react';
import { Navigate } from 'react-router-dom';
import Calendar from "../components/Calendar";


const Homepage = () => {
    if (localStorage.getItem('userRole') === 'technician') {
        return <Navigate to="/technician/requests" replace />;
    }

    return (
        <div>
             <Calendar/>
        </div>
    )
}

export {Homepage}
